/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Segment_Controls_LabelInputs */



/**
* | output |
* | --- |
* | "Segment controls" |
*
* @param {Segment_Event_Group_Segment_Controls_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_segment_controls_label = /** @type {((inputs?: Segment_Event_Group_Segment_Controls_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Segment_Controls_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Controles de segmentation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentsteuerungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сегментные элементы управления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controles de segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("段控件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメントコントロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Controles de segmento")
	return /** @type {LocalizedString} */ ("Segment controls")
});